import type { Middleware } from "@reduxjs/toolkit";
import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "../../features/auth/state/authSlice";
import modalReducer from "./slice/modal/modalSlice";
import { appStateReducer } from "./slice/appStateSlice";
import { mediaReducer } from "../../features/gallery/state/gallerySlice";
import { loadingHandler } from "./loaderHandleMiddleware";
import { contentTypesReducer } from "./slice/contentTypesSlice";
import graphuReducer from "../../features/graph/state/graphuSlice";
import graphLegacyReducer from "../../features/graph/state/graphLegacy";
import graphViewReducer from "../../features/graph/state/graphViewSlice";
import contentFieldSchemaReducer from "../../features/graph/state/contentFieldSchemaSlice";
import helpArticlesReducer from "../../features/graph/state/helpArticlesSlice";
import projectsReducerLegacy from "../../features/graph/state/projectsSliceLegacy";
import { createLogger } from "redux-logger";
import { projectsReducer } from "../../features/projects/state/projectsSlice";
import { teamReducer } from "../../features/team/state/teamSlice";
import { profileReducer } from "../../features/profile/state/profileSlice";
import { downloadClientReducer } from "../../features/downloadClient/state/downloadClientSlice";
import { statsReducer } from "../../features/stats/state/statsSlice";
import { projectGroupReducer } from "../../features/projectGroups/state/projectGroupsSlice";
import { alertsReducer } from "../../features/alert/state/alertsSlice";
import { subscriptionReducer } from "../../features/subscription/state/subscriptionSlice";
import { buildsReducer } from "../../features/builds/state/buildsSlice";
import { enduserStatsReducer } from "../../features/enduserStats/state/enduserStatsSlice";
import { themesReducer } from "src/features/themes/state/themeSlice";
import { chatbotReducer } from "../../features/chatbot/state/chatbotSlice";
import languagesReducer from "../../features/languages/state/languagesSlice";
import { statsNewReducer } from "../../features/statsNew/state/statsNewSlice";
import { deviceInstallerReducer } from "../../features/deviceInstaller/state/deviceInstallerSlice";
import { reportsReducer } from "../../features/reports/state/reportsSlice";
import { ragReducer } from "../../features/rag/state/ragSlice";
import { mfaReducer } from "../../features/mfa/state/mfaSlice";
import { onboardingReducer } from "../../features/onboarding/state/onboardingSlice";
import { onboardingListener } from "../../features/onboarding/state/onboardingListener";

const logger = createLogger({}) as Middleware;

export const store = configureStore({
  reducer: {
    modals: modalReducer,
    auth: authReducer,
    app: appStateReducer,
    builds: buildsReducer,
    media: mediaReducer,
    graphu: graphuReducer,
    graphLegacy: graphLegacyReducer,
    graphView: graphViewReducer,
    contentFieldSchema: contentFieldSchemaReducer,
    helpArticles: helpArticlesReducer,
    profile: profileReducer,
    projects: projectsReducer,
    projectGroups: projectGroupReducer,
    projectLegacy: projectsReducerLegacy,
    contentTypes: contentTypesReducer,
    stats: statsReducer,
    enduserStats: enduserStatsReducer,
    team: teamReducer,
    wixarClientLatestUris: downloadClientReducer,
    alerts: alertsReducer,
    subscription: subscriptionReducer,
    themes: themesReducer,
    chatbot: chatbotReducer,
    languages: languagesReducer,
    statsNew: statsNewReducer,
    deviceInstaller: deviceInstallerReducer,
    reports: reportsReducer,
    rag: ragReducer,
    mfa: mfaReducer,
    onboarding: onboardingReducer,
  },
  middleware: (getDefaultMiddleware) => {
    const defaultMiddlewalu = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["media/resetMediaFilters"],
        // Ignore these field paths in all actions
        // ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        // ignoredPaths: ['items.dates'],
      },
    })
      .prepend(onboardingListener.middleware as Middleware)
      .concat(loadingHandler);
    return (process.env.NODE_ENV === "development" || process.env.REACT_APP_DEBUG) &&
      !process.env.REACT_APP_NO_REDUX_LOGGER
      ? defaultMiddlewalu.concat(logger)
      : defaultMiddlewalu;
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

if (window.Cypress) {
  window.getStore = () => store;
}
